export default __webpack_public_path__ + "static/media/investableAmountIcon.07accafa.svg";